/**
 * Load all the components. needed for the app
 */

import Vue from 'vue'
import { ThemeConsole } from '../themes'
import { LayerEditor } from '../layers'

Vue.component('metaslider-themes', ThemeConsole)
Vue.component('metaslider-layer-editor', LayerEditor)

export default { ThemeConsole, LayerEditor }



// WEBPACK FOOTER //
// ./src/admin/assets/js/app/slideshows/components.js